import { ModalController, IonContent, IonGrid, IonRow, IonCol } from '@ionic/angular';
import { Component, OnInit, ChangeDetectionStrategy, inject, OnDestroy } from '@angular/core';

import { Howl } from 'howler';

@Component({
    selector: 'app-modal-splash-screen',
    templateUrl: './modal-splash-screen.component.html',
    styleUrls: ['./modal-splash-screen.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        IonContent,
        IonGrid,
        IonRow,
        IonCol,
    ],
})
export class SplashScreenModal implements OnInit, OnDestroy {
    private modalCtrl = inject(ModalController);

    private soundAssets = '/assets/sounds/CSI_Sound.mp3';
    private player: Howl = null;
    private closeTimer: ReturnType<typeof setTimeout> | undefined;

    ngOnInit() {
        this.player = new Howl({
            src: this.soundAssets,
            loop: false,
            volume: 0.6,
        });

        this.player.play();

        this.closeTimer = setTimeout(() => {
            this.onPlayerDestroy();
            this.modalCtrl.dismiss();
        }, 5000);
    }

    // Si el modal se destruye antes de los 5 segundos: no cerrar un overlay que ya no existe
    ngOnDestroy() {
        clearTimeout(this.closeTimer);
        if (this.player) {
            this.onPlayerDestroy();
        }
    }

    onPlayerDestroy() {
        this.player.stop();
        this.player = null;
    }
}
